import * as service from "../service";
import { store } from "../../store";

/**
 * Mark a redeemed coupon as used by the student who redeemed it.
 * Backend: PUT /api/coupon/useRedeemedCoupons/useRedeemedCoupons
 */
export const UseRedeemedCouponsAPI = async (coupon_id: string) => {
  try {
    const resp = await service.call(
      "PUT",
      "api/coupon/useRedeemedCoupons/useRedeemedCoupons",
      {
        id: coupon_id,
      },
    );
    return resp;
  } catch (err) {
    console.error(`UseRedeemedCouponsAPI ${err}`);
  }
};

/**
 * Mark a redeemed coupon as used by the business scanning the customer's QR
 * code.
 * Backend: PUT /api/coupon/useRedeemedCoupons/businessScanToUseRedeemedCoupon
 */
export const BusinessScanToUseRedeemedCouponAPI = async (
  id: string,
  coupon_id: string,
) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "PUT",
      "api/coupon/useRedeemedCoupons/businessScanToUseRedeemedCoupon",
      {
        id,
        coupon_id,
        business_id: user?.id,
      },
    );
    return resp;
  } catch (err) {
    console.error(`BusinessScanToUseRedeemedCouponAPI ${err}`);
  }
};
